export default __webpack_public_path__ + "static/media/dick.72447502.png";